import { UserService } from 'api/generated';
import { UseQueryOptions, useQuery } from 'react-query';

export const useEmployeeJobTitlesQueryKey = 'EmployeeJobTitles';
export const useEmployeeJobTitlesQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof UserService.getUsersJobTitles>>,
      unknown,
      Awaited<ReturnType<typeof UserService.getUsersJobTitles>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([useEmployeeJobTitlesQueryKey, ...(queryKey ?? [])], () => UserService.getUsersJobTitles(), options);
